import { render, staticRenderFns } from "./AuthSidebarNaccu.vue?vue&type=template&id=65da2ec0&scoped=true"
import script from "./AuthSidebarNaccu.vue?vue&type=script&lang=js"
export * from "./AuthSidebarNaccu.vue?vue&type=script&lang=js"
import style0 from "./AuthSidebarNaccu.vue?vue&type=style&index=0&id=65da2ec0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65da2ec0",
  null
  
)

export default component.exports